import { Box, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import SelectField from 'modules/core/components/SelectField'
import i18n from 'modules/core/lib/i18n'

import { Concepts } from 'modules/finance/components/FinancialWorkspace/components/Settings/Concepts'

import {
  FinancialWorkspaceSettingsFormValues,
  LABOR_COST_TYPES,
  SOURCE_OF_TRUTH_OPTIONS,
} from './constants'

interface SettingsFormFieldsProps {
  values: FinancialWorkspaceSettingsFormValues
  setFieldValue: (
    field: keyof FinancialWorkspaceSettingsFormValues,
    value: string | number[] | boolean
  ) => void
  defaultConceptIdsToAdd: number[]
  defaultConceptIdsToSubtract: number[]
  showSubtractFromTotal: boolean
  showSubtractEmployeeExpensesSection: boolean
  setExpensesConceptDetected: (detected: boolean) => void
}

export const SettingsFormFields = ({
  values,
  setFieldValue,
  defaultConceptIdsToAdd,
  defaultConceptIdsToSubtract,
  showSubtractFromTotal,
  showSubtractEmployeeExpensesSection,
  setExpensesConceptDetected,
}: SettingsFormFieldsProps) => {
  return (
    <Box width="full" gap="s16">
      <Box width="full" gap="s8">
        <Text.Normal weight="medium" size="300">
          {i18n.t('finance.financial_workspace.settings.labor_cost.source_of_truth')}
        </Text.Normal>

        <SelectField
          hideLabel
          label={i18n.t('finance.financial_workspace.settings.labor_cost.payroll_concept')}
          value={values.laborCostType}
          options={SOURCE_OF_TRUTH_OPTIONS()}
          onChange={(choiceValue) => {
            setFieldValue('laborCostType', choiceValue)
          }}
        />
      </Box>

      <Concepts
        title={
          values.laborCostType === LABOR_COST_TYPES.COMPANY_COST
            ? i18n.t(
                'finance.financial_workspace.settings.labor_cost.source_of_truth_options.concept'
              )
            : i18n.t('finance.financial_workspace.settings.labor_cost.add_to_total.title')
        }
        description={
          values.laborCostType === LABOR_COST_TYPES.COMPANY_COST
            ? i18n.t('finance.financial_workspace.settings.labor_cost.payroll_concepts_description')
            : i18n.t('finance.financial_workspace.settings.labor_cost.add_to_total.description')
        }
        defaultConceptIds={defaultConceptIdsToAdd}
        field="conceptIdsToAdd"
        setFieldValue={setFieldValue}
      />

      {showSubtractEmployeeExpensesSection && (
        <Concepts
          title={i18n.t(
            'finance.financial_workspace.settings.labor_cost.subtract_from_total.title'
          )}
          description={i18n.t(
            'finance.financial_workspace.settings.labor_cost.subtract_from_total.description'
          )}
          defaultConceptIds={defaultConceptIdsToSubtract}
          field="conceptIdsToSubtract"
          setFieldValue={setFieldValue}
          setExpensesConceptDetected={setExpensesConceptDetected}
        />
      )}

      {showSubtractFromTotal && (
        <TogglerCheckbox
          value={values.subtractEmployeeExpenses ?? false}
          label={i18n.t(
            'finance.financial_workspace.settings.labor_cost.subtract_employee_expenses_description'
          )}
          onChange={(subtractEmployeeExpenses) =>
            setFieldValue('subtractEmployeeExpenses', subtractEmployeeExpenses)
          }
        />
      )}
    </Box>
  )
}
